import React, { useState } from 'react'
import { Grid, Divider } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { TextRegular } from './TextStyling'
import serverData from '../api/ServerData'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { logoutUser } from '../actions/loginActions'

export default function FilterJobFunction ({ filterRef }) {
  const theme = useTheme()

  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [check, setCheck] = useState('allJobs')

  return (
    <Grid
      container
      style={{ display: 'flex', marginTop: 24, alignItems: 'center' }}
    >
      <Grid
        onClick={() => {
          setCheck('allJobs')
          filterRef.current.updateFunctionalRoles([])
        }}
        item
        style={{
          cursor: 'pointer'
        }}
      >
        <TextRegular
          style={{
            color:
              check === 'allJobs'
                ? theme.palette.primary.main
                : theme.palette.text.disabled,
            fontSize: '16px'
          }}
        >
          All Jobs
        </TextRegular>
      </Grid>
      <Grid item style={{ margin: '0px 16px' }}>
        <Divider
          orientation='vertical'
          style={{
            backgroundColor: theme.palette.text.disabled,
            width: '1px',
            height: '16px'
          }}
        />
      </Grid>
      <Grid
        onClick={() => {
          setCheck('onlyJobFunction')
          serverData.getMyFunctionalRoles(
            {},
            result => {
              if (result.status) {
                filterRef.current.updateFunctionalRoles(result.response)
              }
            },
            error => {
              if (error.status === 401) {
                dispatch(logoutUser(navigate)) // eslint-disable-next-line
              }
            }
          )
        }}
        item
        style={{
          cursor: 'pointer'
        }}
      >
        <TextRegular
          style={{
            color:
              check !== 'allJobs'
                ? theme.palette.primary.main
                : theme.palette.text.disabled,
            fontSize: '16px',
            lineHeight: '24px'
          }}
        >
          Filter by my functional role
        </TextRegular>
      </Grid>
    </Grid>
  )
}
